import * as Sentry from "@sentry/browser";
import zoomSdk from "@zoom/appssdk";
import Cookie from "js-cookie";

import ROUTES from "@app/common/routes";
import { configureZoomSdk } from "@app/embedded/utils";
import { getAppUrl } from "@app/utils/utils";

export const getOpenAppBrowserUrl = (path: string, search?: string) => {
  const appUserId = encodeURIComponent(Cookie.get("user_cookie") || "");
  const signInUrl = `${getAppUrl(
    ROUTES.SECURE_SIGN_IN
  )}?euid=${appUserId}&redirectTo=${encodeURIComponent(path)}${
    search ? `&${search}` : ""
  }`;
  return signInUrl;
};

/**
 * Opens the given app path in the default browser.
 * Appends user credentials to the path if the user is logged in.
 * so we can automatically log in the user.
 * @param path
 * @param search optional search string
 */
const openAppBrowser = (path: string, search?: string) => {
  Sentry.addBreadcrumb({ message: "openAppBrowser", data: { path } });
  return configureZoomSdk().then(() =>
    zoomSdk.openUrl({ url: getOpenAppBrowserUrl(path, search) })
  );
};

export default openAppBrowser;
